export default __webpack_public_path__ + "static/media/free.4235610f.svg";